import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { LoginService } from "@core/services/login/login.service";

@Injectable({
    providedIn: 'root',
})
export class AuthGuardService implements CanActivate {

    constructor(private loginService: LoginService, private router: Router) {

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.loginService.holeEingeloggtenUser()) {
            return true;
        } else {
            this.router.navigate(["/"]);
            return false;
        }
    }


}
